var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "header align-items-center pl-3 mb-4" },
    [
      _c(
        "b-col",
        [
          _vm.loading
            ? _c("b-skeleton", { attrs: { width: "100%", height: "2rem" } })
            : _c(
                "b-row",
                { staticClass: "header" },
                [
                  _c("back-button", { attrs: { "static-route": "agents" } }),
                  _vm._v(" "),
                  _c(
                    "profile-avatar",
                    _vm._b(
                      { staticClass: "client-avatar mr-3" },
                      "profile-avatar",
                      _vm.agent,
                      false
                    )
                  ),
                  _vm._v(" "),
                  _c("h2", { staticClass: "header-title" }, [
                    _vm._v("\n        " + _vm._s(_vm.fullname) + "\n      "),
                  ]),
                ],
                1
              ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "d-flex flex-column align-items-end" },
        [
          _c("simple-button", {
            staticClass: "d-lg-inline d-none",
            attrs: {
              text: _vm.$t("global.actions.saveChanges"),
              disabled: !_vm.canSave,
              loading: _vm.saving,
              "loading-succeeded": _vm.savingSucceeded,
            },
            on: { click: _vm.handleSubmit },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "dropleft d-lg-none" }, [
            _c(
              "a",
              {
                staticClass: "grey-text text-darken-4 clickable d-xl-none",
                attrs: { "data-toggle": "dropdown" },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("more_vert"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-menu" }, [
              _c("div", { staticClass: "dropdown-item clickable wide px-4" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-white",
                    attrs: { disabled: !_vm.canSave },
                    on: { click: _vm.handleSubmit },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("global.actions.saveChanges")) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }